export class InviteStaffToPivotModel {
    type: string;
    staffnm?: string;
    mail?: string;
    phone?: string;
}